import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Signup_page1 from "../assets/img/Signup_page1.png";

import axios from "axios";

const ProfilePage = () => {
  const [formData, setformData] = useState({
    name: "",
    email: "",
    contact_no: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [inputValue, setInputValue] = useState();
  const [errors, setErrors] = useState("");
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();
  const handleChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
    console.log(setformData);
  };
  const handleDropdownChange = (e) => {
    setSelectedOption(e.target.value);
    setInputValue(""); //If select option changes it clears previous text in the input
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const getPlaceholder = () => {
    switch (selectedOption) {
      case "Student":
        return "Institution Name";
      case "Administrator":
        return "Hospital/Institution Name";
      case "Research Associate":
        return "Institution Name";
      case "Doctor":
        return "Hospital/Institution Name";
      case "Others":
        return "Others/Profession/Institution Name";
      default:
        return "Description";
    }
  };
  const nameValidator = (firstName) => {
    const namePattern = /^[A-Za-z\s]+$/;
    return namePattern.test(firstName);
  };
  const emailValidator = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const contactNumberValidator = (contact_no) => {
    const contactNumberRegex = /^(0\d+-?\d+|\+91\d+|\+\d+|\d{10,})$/;
    return contactNumberRegex.test(contact_no);
  };
  const validateSignup = () => {
    const errorMsg = {};
    if (!formData.name.trim()) {
      errorMsg.name = "Name is required";
    } else if (!nameValidator(formData.name)) {
      errorMsg.name = "Name should contain only letters and spaces.";
    }
    if (!formData.email) {
      errorMsg.email = "Email is Required";
    } else if (!emailValidator(formData.email)) {
      errorMsg.email = "Invalid email Format";
    }
    // if (!formData.contact_no.trim()) {
    //   errorMsg.contact_no = "Contact number is required ";
    // } else if (!contactNumberValidator(formData.contact_no)) {
    //   errorMsg.contact_no("Please enter valid Contact NUmber");
    // }
    if (formData.contact_no && !contactNumberValidator(formData.contact_no)) {
      errorMsg.contact_no = "Please enter valid Contact Number";
    }
    if (!selectedOption) {
      errorMsg.selectedOption = "Occupation is required";
    }
    if (!inputValue) {
      errorMsg.inputValue = "Description is required";
    }
    setErrors(errorMsg);
    return Object.keys(errorMsg).length === 0;
  };
  useEffect(() => {
    const storedUser = sessionStorage.getItem("userDetails"); //by using key we get the userdetails in the session storage
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserDetails(parsedUser);
      // console.log(setUserDetails);
      setformData({
        name: parsedUser.name || "",
        email: parsedUser.email || "",
        contact_no: parsedUser.contact_no || "",
      });
      setSelectedOption(parsedUser.occupation || "");
      setInputValue(parsedUser.description || "");
    }
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...formData,
      occupation: selectedOption,
      description: inputValue,
    };
    if (!validateSignup()) return;
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const Response = await axios.post("/profile-update", data, {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in headers
          "Content-Type": "application/json",
        },
      });
      console.log(Response);

      const userData = Response.data;
      console.log("userData:", userData);
      if (userData.response_code === 200) {
        // setStatus(userDetails.message);
        sessionStorage.setItem("userDetails", JSON.stringify(data));
        setStatus({
          response_code: userData.response_code,
          message: userData.message,
        });
      } else if (userData.response_code === 400) {
        setStatus({
          response_code: userData.response_code,
          message: userData.message,
        });
        // setStatus(userDetails.message);
      } else if (userData.response_code === 422) {
        setStatus({
          response_code: userData.response_code,
          message: userData.message,
        });
        // setStatus(userDetails.message);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  console.log(status);

  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 profile-container">
        <div className="col-12 col-md-6 profile-image-col">
          <img
            src={Signup_page1}
            alt="Signup_page1"
            className="img-fluid"
          ></img>
        </div>
        <div className="col-12 col-md-6 profile-form-col">
        <div className="profile-content">
          <div className="d-flex flex-column align-items-center w-100 profile-header">
            <h2 className="fs-4 mb-4 text-center">Profile</h2>
          </div>
          <form className="profile-form" onSubmit={handleSubmit}>
            {/* Status message */}
            {status.response_code && (
              <div
                className="modal fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div
                      className={`modal-header ${
                        status.response_code === 200
                          ? "bg-primary text-white"
                          : "bg-primary text-white"
                      }`}
                    >
                      <h5 className="modal-title">UpdateProfile</h5>
                    </div>

                    <div className="modal-body">
                      <p className="text-center">{status?.message}</p>
                    </div>

                    <div className="modal-footer">
                      {status.response_code === 200 ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => navigate("/")}
                        >
                          Ok
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setStatus("")}
                        >
                          Close
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <input
              type="name"
              name="name"
              value={formData.name}
              className=" form-control  p-2  mb-3"
              placeholder="Name"
              onChange={handleChange}
            ></input>
            {errors.name && <p className="text-danger small">{errors.name}</p>}
            <input
              type="email"
              name="email"
              value={formData.email}
              className="form-control p-2  mb-3"
              placeholder="email"
              onChange={handleChange}
            ></input>
            {errors.email && (
              <p className="text-danger small">{errors.email}</p>
            )}
            <input
              type="tel"
              name="contact_no"
              value={formData.contact_no}
              className=" form-control 
              p-2 mb-3"
              placeholder="Contact Number"
              onChange={handleChange}
            ></input>
            {errors.contact_no && (
              <p className="text-danger small">{errors.contact_no}</p>
            )}
            <select
              className="form-select p-2  mb-3"
              name="occupation"
              value={selectedOption}
              onChange={handleDropdownChange}
            >
              <option value="">Select Occupation</option>
              <option value="Student">Student</option>
              <option value="Administrator">Administrator</option>
              <option value="Research Associate">Research Associate</option>
              <option value="Doctor">Doctor</option>
              <option value="Others">others</option>
            </select>
            {errors.selectedOption && (
              <p className="text-danger small">{errors.selectedOption}</p>
            )}
            {selectedOption && (
              <div>
                <input
                  type="text"
                  name="description"
                  value={inputValue}
                  className="form-control p-2 mb-3"
                  placeholder={getPlaceholder()}
                  onChange={handleInputChange}
                />
                {errors.inputValue && (
                  <p className="text-danger small">{errors.inputValue}</p>
                )}
              </div>
            )}

            <div className="d-flex justify-content-center gap-3 mb-4">
              <button
                type="submit"
                className="btn btn-primary me-4 mb-3 px-4"
                disabled={loading}
              >
                {loading ? (
                  <div className="spinner-border text-light" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  "Update Profile"
                )}
              </button>
            </div>
          </form>
        </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
